(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-celebration-guide"]) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-sp-print]');if(!button)return;document.documentElement.dataset.spPrint=button.dataset.spPrint;window.print();});window.addEventListener('afterprint',()=>{delete document.documentElement.dataset.spPrint;});

  } catch(e) { console.error(e); }
})();
})();
